module.exports = __webpack_public_path__ + "files/44e671398cea7458f0d7674671b515c8.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-2.png
// module id = 499
// module chunks = 76